import React, { useMemo } from 'react';
import { EnumCellProps, WithClassname } from '@jsonforms/core';
import { Select } from '@mantine/core';
import merge from 'lodash/merge';
import { TranslateProps } from '@jsonforms/react';
import { i18nDefaults } from '../utils';
import { WithInputProps } from './interfaces';

export const MantineSelect = React.memo(function MantineSelect(
  props: EnumCellProps & WithClassname & TranslateProps & WithInputProps
) {
  const { data, className, id, enabled, schema, uischema, path, handleChange, options, config, label, t } = props;
  const appliedUiSchemaOptions = useMemo(() => merge({}, config, uischema.options), [config, uischema.options]);
  const noneOptionLabel = useMemo(
    () => t('enum.none', i18nDefaults['enum.none'], { schema, uischema, path }),
    [t, schema, uischema, path]
  );

  const handleSelectChange = (value: string | null) => {
    handleChange(path, value || undefined);
  };

  return (
    <Select
      className={className}
      miw={200}
      maw={320}
      id={id}
      label={label}
      disabled={!enabled}
      autoFocus={appliedUiSchemaOptions.focus}
      value={data !== undefined ? data : ''}
      onChange={handleSelectChange}
      data={[
        { value: '', label: noneOptionLabel },
        ...(options || []).map((optionValue) => ({
          value: optionValue.value,
          label: optionValue.label,
        })),
      ]}
      clearable
      searchable
    />
  );
});
